import { useParams } from "react-router-dom";
import "./case-page.sass";
import { useEffect, useState } from "react";
import { getCaseBySlugApi } from "../../api/api";
import Loading from "../../components/common/loading/loading";
import { EContentBlockType } from "../../types/enum";
import { TCase, TContentBlockTextAndImage } from "../../types/types";
import CaseParser from "../../components/common/case-parser/case-parser";

const CasePage = () => {
  const { caseId } = useParams();
  const [caseData, setCaseData] = useState<TCase | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  const isAbortError = (error: unknown) =>
    error instanceof DOMException && error.name === "AbortError";

  useEffect(() => {
    if (!caseId) {
      setLoadError("Не удалось определить кейс.");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const controller = new AbortController();

    getCaseBySlugApi(caseId, { signal: controller.signal })
      .then((data) => {
        setCaseData(data.data);
        setLoadError("");
      })
      .catch((error) => {
        if (isAbortError(error)) {
          return;
        }
        setLoadError("Не удалось загрузить кейс.");
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      });

    return () => {
      controller.abort();
    };
  }, [caseId, reloadKey]);

  useEffect(() => {
    if (!caseData) {
      return;
    }
    const rightApproachBlock = caseData.contentBlocks.find(
      (contentBlock): contentBlock is TContentBlockTextAndImage =>
        contentBlock.__component === EContentBlockType.TEXT_AND_IMAGE &&
        contentBlock.imagePosition === "right",
    );
    if (!rightApproachBlock) {
      return;
    }
    document.title = rightApproachBlock.heading;
    const description = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );
    if (description) {
      description.setAttribute("content", rightApproachBlock.text);
    }
  }, [caseData]);

  return isLoading ? (
    <Loading isLoading={isLoading} />
  ) : (
    <div className="page case-page">
      {loadError && <div className="error">{loadError}</div>}
      {loadError && (
        <button
          type="button"
          className="link"
          onClick={() => setReloadKey((prev) => prev + 1)}
        >
          Повторить загрузку
        </button>
      )}
      {!loadError &&
        !caseData &&
        !isLoading && <div className="error">Кейс не найден.</div>}
      {caseId &&
        caseData &&
        caseData.contentBlocks.map((contentBlock, index) => (
          <CaseParser
            key={`${caseData.id}-${contentBlock.id}-${index}`}
            contentBlock={contentBlock}
          />
        ))}
    </div>
  );
};

export default CasePage;
